import { useSelector } from "react-redux";
import { RootState } from "../store/store";

/** Admin feedback in the event sidebar when status is rejected. */
export default function EventRejectionSidebarRemark() {
  const event = useSelector((state: RootState) => state.event);

  if (event?.status !== "rejected") {
    return null;
  }

  const remark = event.admin_remark?.trim();

  return (
    <div className="sidebar-rejection-remark">
      <p className="sidebar-rejection-remark__title">Admin comment</p>
      <p className="sidebar-rejection-remark__text">
        {remark ||
          "Your event was rejected. Update the required sections and resubmit."}
      </p>
      <p className="sidebar-rejection-remark__hint">
        Resubmit from Review &amp; Publish when ready.
      </p>
    </div>
  );
}
